import { Component } from '@angular/core';
import { NgFor } from '@angular/common';

type Stat = { value: string; label: string; icon: string; tone: 'a'|'b'|'c'|'d' };

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [NgFor],
  template: `
  <section class="section">
    <div class="head">
      <h2 class="h2">Impact clients</h2>
      <p class="sub">Résultats typiques observés après mise en place de dashboards & pipelines fiables.</p>
    </div>

    <div class="grid">
      <div class="tile" *ngFor="let s of stats" [class]="s.tone">
        <div class="tile__top">
          <span class="ic">{{s.icon}}</span>
          <div class="val">{{s.value}}</div>
        </div>
        <div class="lab">{{s.label}}</div>
      </div>
    </div>
  </section>
  `,
  styles: [`
    .section{
      border-radius: 26px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.03);
      padding: 18px;
      box-shadow: 0 30px 120px rgba(0,0,0,.45);
    }

    .head{
      display:flex;
      align-items:flex-end;
      justify-content:space-between;
      gap:12px;
      flex-wrap:wrap;
    }

    .sub{
      margin: 0;
      color: rgba(235,240,255,.70);
      font-weight: 750;
      max-width: 560px;
    }

    .grid{
      margin-top: 14px;
      display:grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 12px;
    }

    .tile{
      border-radius: 22px;
      border: 1px solid rgba(255,255,255,.10);
      background: rgba(255,255,255,.04);
      padding: 14px;
      position:relative;
      overflow:hidden;
      min-height: 120px;
    }

    .tile::before{
      content:"";
      position:absolute;
      inset:-60px;
      opacity:.7;
      pointer-events:none;
    }

    .a::before{ background: radial-gradient(circle at 20% 20%, rgba(79,125,255,.35), transparent 55%); }
    .b::before{ background: radial-gradient(circle at 20% 20%, rgba(0,229,168,.28), transparent 55%); }
    .c::before{ background: radial-gradient(circle at 20% 20%, rgba(168,85,247,.26), transparent 55%); }
    .d::before{ background: radial-gradient(circle at 20% 20%, rgba(255,193,7,.22), transparent 55%); }

    .tile__top{
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:12px;
      position:relative;
    }

    .ic{
      width:38px; height:38px;
      display:grid; place-items:center;
      border-radius: 16px;
      border: 1px solid rgba(255,255,255,.12);
      background: rgba(255,255,255,.06);
      box-shadow: 0 16px 50px rgba(0,0,0,.35);
      flex: 0 0 auto;
    }

    .val{
      font-size: 28px;
      font-weight: 1000;
      letter-spacing: -0.5px;
      position:relative;
    }

    .lab{
      margin-top: 10px;
      color: rgba(235,240,255,.72);
      font-weight: 800;
      position:relative;
    }

    /* ✅ Tablet */
    @media (max-width: 960px){
      .section{ padding: 16px; border-radius: 22px; }
      .grid{ grid-template-columns: repeat(2, 1fr); }
    }

    /* ✅ Phone (Hero-like density) */
    @media (max-width: 560px){
      .section{ padding: 14px; border-radius: 20px; }
      .grid{ gap: 10px; margin-top: 10px; }

      .tile{
        padding: 12px;
        border-radius: 18px;
        min-height: 96px;
      }

      .ic{ width: 34px; height: 34px; border-radius: 14px; }
      .val{ font-size: 22px; letter-spacing: -0.3px; }
      .lab{ margin-top: 8px; font-size: 12px; }
      .sub{ font-size: 13px; line-height: 1.6; }
    }
  `]
})
export class TestimonialsComponent {
  stats: Stat[] = [
    { value: '-67%', label: 'Temps de reporting', icon: '⏱️', tone: 'a' },
    { value: '+18%', label: 'Croissance (modèle IA)', icon: '📈', tone: 'c' },
    { value: '+32%', label: 'Performance KPI', icon: '🎯', tone: 'b' },
    { value: '99.9%', label: 'Qualité de données', icon: '🛡️', tone: 'd' },
  ];
}
